import { ASYNC } from "../constants/ActionTypes"
const asyncInitialState = {}
export default function (state = asyncInitialState, action = {} ){
    switch(action.type){
        case ASYNC.GET_SEARCH_PLACEHOLDER:
            return Object.assign({},state,{
                searchPlaceHolder: action.GET_SEARCH_PLACEHOLDER
            })
            break;
        case ASYNC.GET_SEARCH_HOT_WORLD:
            return Object.assign({},state,{
                searchHotWords: action.GET_SEARCH_HOT_WORLD
            })
            break;
        case ASYNC.GET_NAVIGATION_GROUP:
            return Object.assign({},state,{
                navigationGroup: action.GET_NAVIGATION_GROUP
            })
            break;
        case ASYNC.GET_NAVIGATION_BRAND_GROUP:
            return Object.assign({},state,{
                navigationBrandGroup: action.GET_NAVIGATION_BRAND_GROUP
            })
            break;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./common/reducers/async.js